'use strict';

/**
 * CommissionModule — commission config CRUD (direct paymentSystem calls).
 *
 * Config cascade: merchant-specific → vendor default (isDefault) → DISTRIBUTOR fallback.
 * txnType values: REGISTRATION | VALIDATION | TRANSFER | NONE
 */
class CommissionModule {
  constructor(client) {
    this._c = client;
  }

  list(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/commission${qs}`);
  }

  get(configId) {
    return this._c.rawGet(`/api/v1/commission/${configId}`);
  }

  /**
   * Create a commission config.
   * @param {{
   *   vendorId: string,
   *   aggregatorId: string,
   *   paymentMethod: "DMT"|"AEPS"|"QR",
   *   provider: "NSDL"|string,
   *   txnType: "REGISTRATION"|"VALIDATION"|"TRANSFER"|"NONE",
   *   chargeType: "FIXED"|"PERCENTAGE"|"NONE",
   *   chargeValue: number,
   *   merchantId?: string,
   *   isDefault?: boolean
   * }} body
   */
  create(body) {
    return this._c.rawPost('/api/v1/commission/create', body);
  }

  /**
   * Update an existing commission config.
   * @param {string} configId
   * @param {object} body — partial fields to update
   */
  update(configId, body) {
    return this._c.rawPost(`/api/v1/commission/${configId}/update`, body);
  }

  delete(configId) {
    return this._c.rawPost(`/api/v1/commission/${configId}/delete`, {});
  }
}

module.exports = { CommissionModule };
